<div class="dialog-container  px-6 pt-6 " style="padding-bottom: .65rem;">
    <div class="dialog-header">
      <div class="material-icon-wrapper" ngClass="warning">
        <span class="material-icons">warning</span>
      </div>
      <h3  class="title-header" >Warning</h3>
    </div>
  
    <mat-dialog-content style="padding: 0px !important;">
      <p class="m-0" >Your Session is about to expire.</p>
      <p style="padding-bottom: 1rem;" class="m-0">You will be logged out in {{counter}} seconds.</p>
    </mat-dialog-content>
  
    <mat-dialog-actions class="p-0">
      <div class="dialog-actions">
        <button [ngClass]="'warning'" type="button" class="submit" (click)="confirmDialog()">
          Logout
        </button>
  
        <button type="button" class="cancel" style="margin-left: 10px;" (click)="closeDialog()">
            Continue Session
        </button>
      </div>
    </mat-dialog-actions>
  </div>
  